window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productQuantityInput: '#Quantity',
    validatePostalCode: '[data-validate-postal-code]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    try {
      this.productVariantsQuantityObject = JSON.parse($('[data-product-variants-json').html());
      this.productSingleObject.variants.map(variant => {
        variant.inventory_quantity = this.productVariantsQuantityObject[variant.id]
      });
    }catch(e) {
      console.log(e);
    }
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $(selectors.productQuantityInput).prop('max',variant.inventory_quantity);
        if(variant.inventory_quantity < 10){
         $(".inventory-alert").text("Almost Gone, Order Today!") 
        }
        else{
         $(".inventory-alert").text("");
        }
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.productQuantityInput).prop('max',variant.inventory_quantity);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Navigate To Section Script
 * ------------------------------------------------------------------------------
 * Manages the 'Navigate To' menu on the SHOP page
 *
 */

(function() {
  var regex = {
    createHandle: {
      s: /\ /gi,
      r: '-'
    }
  };

  var selectors = {
    navButton: '[data-navigate-to]',
    collectionList: '.collection-section',
    siteNav: '#shopify-section-header'
  };

  $(selectors.navButton).on('click', function( evt ) {
    evt.preventDefault();
    if ($(this).hasClass('inactive')) {
      return;
    }

    var gotoCollection = this.dataset.navigateTo.toLowerCase()
        gotoTarget = $(['#collection-handle-', gotoCollection.replace(regex.createHandle.s, regex.createHandle.r)].join(''))
        siteNavHeight = $(selectors.siteNav).height();

    $('html, body').animate({
      scrollTop: gotoTarget.offset().top - siteNavHeight
    }, 500);
  });

})();

/**
 *
 * Filters Mobile Menu
 * ------------------------------------------------------------------------------
 *
 */

(function() {

  var $sidebar = $('#filter-sidebar'),
      $button = $('#small-filter-button');
      $closeButton = $('.nav-menus-wrapper-close-button.filter-sidebar-close-button');
  $button.on('click', function ( evt ) {
    evt.preventDefault();

    $('body').toggleClass('filter-active');
    $sidebar.toggleClass('open');

    if ($sidebar.hasClass('open') ) {
      $button.text('Close');
    } else {
      $('body').removeClass('filter-active');
      $button.text('Filters');
    };

  });

  $closeButton.on('click', function ( evt ) {
    evt.preventDefault();

    $('body').toggleClass('filter-active');
    $sidebar.toggleClass('open');

    if ($sidebar.hasClass('open') ) {
      $button.text('Close');
    } else {
      $('body').removeClass('filter-active');
      $button.text('Filters');
    };

  });

})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.collection = (function() {
  var config = {
    pagePath: window.location.pathname,
    templatePath: '/collections/shop',
    search: window.location.search,
    $products: $('.collection-product'),
    navigateToButton: '[data-navigate-to]',
    $collectionList: $('.collection-section'),
    siteNav: '#shopify-section-header',
    filterQuery: []
  };

  if (config.templatePath !== config.pagePath) {
    return;
  }

  /*
   * Add unique values to filterQuery
   */
  function addFilter( item ) {
    if(config.filterQuery.indexOf( item ) === -1) {
      config.filterQuery.push( item );
    }
  }

  /*
   * Remove unique values to filterQuery
   */
  function deleteFilter( item ) {
    var idx = config.filterQuery.indexOf( item );
    if(idx != -1) {
      config.filterQuery.splice( idx, 1 );
    }
  }

  /*
   * Update product list based on filterQuery;
   * if the list empty, show all
   */
  function updateProductList() {
    var $el, tags, x, count = 0;

    if (config.filterQuery.length === 0) config.$collectionList.show(), config.$products.show();
      else {
        config.$collectionList.hide();
        $('.collection-product').hide().each(function ( idx, el ) {
          $el = $(el);
          tags = $el.data('product-tags').split(',');
          for (x = 0; x < config.filterQuery.length; x++) {
            if (tags.indexOf(config.filterQuery[x]) != -1) {
              $el.show();
              $el.parent().show();
              count++;
            }
          }

          if (count > 0) {
            $el.parent().show();
          }
        });


        // if none of the search query match our filter properties
        // show all products
        if (count == 0) {
          config.$collectionList.show();
          config.$products.show();
        }
      }
  }

  /*
   * Check checkboxes based on filterQuery;
   */
  function updateCheckboxes() {
    var x;
    for (x = 0; x < config.filterQuery.length; x++) {
      document.getElementById(config.filterQuery[x]).checked = true;
    }
  }

  /*
   * Uncheck checkboxes
   */
  function uncheckCheckboxes() {
    $('input[name="filter-option"]').each(function ( idx, el ) {
      document.getElementById(el.id).checked = false;
    });
  }

  /*
   * Update Collection Section(s) based on filterQuery
   */
  function updateCollectionSections() {
    $.each($(config.$collectionList), function (idx, el) {
      var $el = $(el),
          id = $el.attr('id'),
          visibleChildren = $el.find('.collection-product:visible').length,
          navTarget = $(['[data-navigate-to="', id.replace('collection-handle-', '')].join(''));

      if (visibleChildren != 0) navTarget.removeClass('inactive');
        else {
          $el.hide();
          navTarget.addClass('inactive');
        }
    });
  }

  /*
   * Clean Search Query from non supported key/value pairs
   */
  function clearFilterQuery () {
    var n = 0, m = config.filterQuery.length, el, cnt;
    var q = [];
    for (n = 0; n < m; n++) {
      el = config.filterQuery[n];
      cnt = el.indexOf('brand_') + el.indexOf('merchandise');
      if (cnt != -2) {
        q.push(el);
      }
    }

    if (q.length != 0) {
      config.filterQuery = q;
    }
  }

  /*
   * Performs the following anytime there's an update to be made
   */
  function doUpdate () {
    updateCheckboxes();
    updateProductList();
    updateCollectionSections();

    if (config.filterQuery.length != 0) {
      var siteNavHeight = $(config.siteNav).height();
      var navigateTo = $('#shopify-section-navigate-to');
      $([document.documentElement, document.body]).animate({
        scrollTop: navigateTo.offset().top - siteNavHeight
      }, 500);
    }
  }

  // add event listener to filter checkboxes; use document level listeners
  // so that the input change is complete because if it's not we will set
  // dependant values to the old value
  document.addEventListener('change', function(ev) {
    if (ev.target.name === "filter-option")
    {
      if( ev.target.checked ) addFilter( ev.target.id );
        else deleteFilter( ev.target.id );

      doUpdate();
    }
  });

  /*
   * Clear query and uncheck all checkboxes
   */
  $('.clear-filter-button').on('click', function ( evt ) {
    evt.preventDefault();
    uncheckCheckboxes();
    config.filterQuery = [];
    doUpdate();
  });


  /*
   * Due to Shopify's Theme Editor, lets make sure we only read the filter key/value paring
   * The following clears the default values if the parameter filter is not found
   */

  if ( config.search.length != 0 && config.search.indexOf('filter=') == -1 ) {
    config.search = "";
  }

  /*
   * page has finished loading so lets look throught the search query
   * for any predefined filters; if there are none, we'll double check
   * if any checkboxes are pre-selected due to a user initiated page
   * refresh.
   *
   * the default view is to show all
   */

  if (config.search.length != 0) {

    config.filterQuery = config.search.substr(config.search.indexOf('=') + 1, config.search.length ).split('&');

    if (config.filterQuery.length == 0) {
      // go through checkboxes
      $('input[name="filter-option"]').each(function ( idx, elm ) {
        if ($(this).prop('checked')) {
          config.filterQuery.push( $(this).attr('id') );
        }
      });
    }
  }

  /*
   * Clone Customer Adivsory message
   */
  if ( $('[data-clone]').length != 0 ) {
    var $this = $('[data-clone]');

    // target id
    var t_id = $this.data('clone');

    // html
    $this.clone().appendTo( $( ['#',t_id].join('') ) );

  }

  clearFilterQuery();
  doUpdate();
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.cart = (function() {
  jQuery('body').on('click', '[name="add"], [data-add-to-cart]', function( evt ) {

    /*
     * Pinterest Floodlight Tag Implementation
     * TODO: Add logic for Buy X Get Y offers
     */
    if (typeof pintrk === 'function') {
      pintrk('track', 'addtocart', {
        value: ( Number($('meta[itemprop="price"]').attr('content')) * Number($('#Quantity').val())),
        order_quantity: $('#Quantity').val(),
        currency: $('meta[itemprop="priceCurrency"]').attr('content'),
        line_items: [
          {
            product_name: $('meta[itemprop="name"]').attr('content'),
            product_price: $('meta[itemprop="price"]').attr('content'),
            product_quantity: $('#Quantity').val(),
            product_brand: $('meta[itemprop="brand"]').attr('content')
          }
        ]
      });
    }

    /*
     * Holiday Floodlight Tag
     */
    if (typeof ENGJPWisersAddtoCart === 'function') {
      ENGJPWisersAddtoCart({
        'allow_custom_scripts': true,
        'u2': String($('meta[itemprop="name"]').attr('content')),
        'u3': String($('#Quantity').val()),
        'send_to': 'DC-9469130/corby000/eng_j0+standard'
      });
    }

    $(this).submit();

  });
})();


/*================ Corby ================*/
var CORBY = (function () {
  var
      id = 'CORBY',

      /*
       * Application's version
       */
      version = '0.1',

      /*
       * Perform the following when page loads
       */
      __constructor = function () {
        // do nothing for now...
      }();

  return {
    get: function ( prop ) {
      return prop;
    }
  };
}());

CORBY.Site = (function (Corby, $, dom, win) {
  var
      id = 'CORBY.Site',

      /*
       * Current URL
       */
      href,

      /*
       * Current Language
       */
      lang = 'ca',

      /*
       * Site's Brand
       */
      brand = 'J.P. Wisers Experience',

      /*
       * Brand Id
       */
      brand_id = 'jpw',

      __constructor = function () {
      }();

  function validate_users_pc( users_pc ) {

    // those who are new, save pc to memory
    var rememberpc_cookie_name = ['corby', 'rememberpc', CORBY.Site.getBrandId(), CORBY.Site.getLang()].join('-');
    CORBY.Cookie.create(
      rememberpc_cookie_name,
      users_pc
    );

    // check if postal code found in restricted area
    var pcs = 'P0L1S0,N7T7H5,P0L1H0,K0K2X0,K0J1X0,P9N3X7,P0T1G0,P9N3X8,P0W1J0,P0T1B0,P0M2M0,P0L1A0,P0P1K0,P6A5K9,P0V1E0,L0K1C0,P0W1J0,P0T1R0,P0T2B0,P7B6C6,P0M1K0,N8H1P5,P0V1J0,P0M1K0,P6B4H5,L0E1R0,N0N1J1,N0H2T0,L3V6H6,N0L1Y0,P0L1B0,P9A3M3,K0L1R0,P0V1N0,P0M2N1,P0T1L0,P0V3H0,P0T2J0,P0V1W0,P7J1L3,P6A6Z8,P0T2A0,P0X1B0,P7B6P9,P0G1J0,K9J0E6,P0X1E0,P0V1Y0,P0V3G0,P0V1Z0,P0V1G0,P7B4A3,P9A3M9,P0V1X0,P0T2A0,P0P1G0,P0G1A0,P0T2L0,P0K1M0,P0M1W0,P0V2M0,P0S1K0,P0V2H0,P6A6Z1,P0R1B0,L9L1B6,N0A1H0,P9A3M9,H0M1A0,K0K1X0,P0L1W0,P0C1H0,N0P2K0,N0L1Y0,P0V3B0,P0W1C0,P0X1L0,P0T1Z0,P0T3B0,P9A3M5,P9N0J2,P2B3K2,P0V2Y0,P0V2G0,P9N3X7,P0V2S0,P0X1K0,N0L2G0,P0T3C0,P0M2J0,P0V2L0,P0V3E0,P0W1E0,P0T2J0,P0V2P0,P0P1P0,P0V1V0,N0H2L0,P0W1H0,P0P1B0,P0G1G0,P0P1W0,P0P1X0,P0X1E0,N0A1M0,P0V3C0,P0L1C0,P0H1C0,P0R1L0,P0X1P0,P8N2Y4,P0K1N0,P0M1H0,P0C1A0,N8A4K9,P0V1B0,P2A2X4,P0X1C0,P8T1A8,P0T3A0,P0L2H0,P0P1A0,P0T1A0,P0P2J0,P0V2Z0,P0P1X0'.split(',');
    if (pcs.indexOf(users_pc) != -1) {
      $('.on-na').show();
      $('.on, .product-form').hide();
      return false;
    }

    // check if postal code is outside of ON
    if('Y,X,V,T,S,R,J,H,G,A,B,C,E'.split(',').indexOf(users_pc.charAt(0)) != -1) {
      var elem = new Foundation.AccordionMenu($('.ca-na ul'));
      $('.ca-na').show();
      $('.on, .product-form').hide();
      return false;
    }

    // show default webform
    $('.on, .product-form').show();

    // disable postal code mini-form
    $('.on').addClass('has_restrictions');
    $('[data-validate-my-postal-code]').attr('disabled', 'disabled');
    $('#ValidatePostalCode').attr('disabled', 'disabled');

    // enable add to cart mini-form
    $('.product-form').removeClass('has_restrictions');
    $('#qtyDown, #Quantity, #qtyUp, [data-add-to-cart]').removeAttr('disabled');
  }


  function returning_pc_users( users_pc ) {

    // check if postal code found in restricted area
    var pcs = 'P0L1S0,N7T7H5,P0L1H0,K0K2X0,K0J1X0,P9N3X7,P0T1G0,P9N3X8,P0W1J0,P0T1B0,P0M2M0,P0L1A0,P0P1K0,P6A5K9,P0V1E0,L0K1C0,P0W1J0,P0T1R0,P0T2B0,P7B6C6,P0M1K0,N8H1P5,P0V1J0,P0M1K0,P6B4H5,L0E1R0,N0N1J1,N0H2T0,L3V6H6,N0L1Y0,P0L1B0,P9A3M3,K0L1R0,P0V1N0,P0M2N1,P0T1L0,P0V3H0,P0T2J0,P0V1W0,P7J1L3,P6A6Z8,P0T2A0,P0X1B0,P7B6P9,P0G1J0,K9J0E6,P0X1E0,P0V1Y0,P0V3G0,P0V1Z0,P0V1G0,P7B4A3,P9A3M9,P0V1X0,P0T2A0,P0P1G0,P0G1A0,P0T2L0,P0K1M0,P0M1W0,P0V2M0,P0S1K0,P0V2H0,P6A6Z1,P0R1B0,L9L1B6,N0A1H0,P9A3M9,H0M1A0,K0K1X0,P0L1W0,P0C1H0,N0P2K0,N0L1Y0,P0V3B0,P0W1C0,P0X1L0,P0T1Z0,P0T3B0,P9A3M5,P9N0J2,P2B3K2,P0V2Y0,P0V2G0,P9N3X7,P0V2S0,P0X1K0,N0L2G0,P0T3C0,P0M2J0,P0V2L0,P0V3E0,P0W1E0,P0T2J0,P0V2P0,P0P1P0,P0V1V0,N0H2L0,P0W1H0,P0P1B0,P0G1G0,P0P1W0,P0P1X0,P0X1E0,N0A1M0,P0V3C0,P0L1C0,P0H1C0,P0R1L0,P0X1P0,P8N2Y4,P0K1N0,P0M1H0,P0C1A0,N8A4K9,P0V1B0,P2A2X4,P0X1C0,P8T1A8,P0T3A0,P0L2H0,P0P1A0,P0T1A0,P0P2J0,P0V2Z0,P0P1X0'.split(',');
    if (pcs.indexOf(users_pc) != -1) {
      $('.on-na').show();
      return false;
    }

    // check if postal code is outside of ON
    if('Y,X,V,T,S,R,J,H,G,A,B,C,E'.split(',').indexOf(users_pc.charAt(0)) != -1) {
      var elem = new Foundation.AccordionMenu($('.ca-na ul'));
      $('.ca-na').show();
      return false;
    }


    // show default webform
    $('.on, .product-form').show();

    // disable postal code mini-form
    $('.on').addClass('has_restrictions');
    $('[data-validate-my-postal-code]').attr('disabled', 'disabled');
    $('#ValidatePostalCode').attr('disabled', 'disabled');

    // enable add to cart mini-form
    $('.product-form').removeClass('has_restrictions');
    $('#qtyDown, #Quantity, #qtyUp, [data-add-to-cart]').removeAttr('disabled');
  }

  return {
    getId: function () {
      return id;
    },

    getURL: function () {
      return href;
    },

    getLang: function () {
      return lang;
    },

    getBrandId: function () {
      return brand_id;
    },

    init: function () {
      href = window.location.href;

      /*
       * TODO USE WITH FREE SHIPPING BAR application
      //Keep Track of the fixed menu size
      var fm = $('#shopify-section-header');
      var fme = $('.fixed-menu-extender');

      function fmResize () {
        fme.height( [fm.height(), 'px'].join('') );
      };

      window.addEventListener("resize", fmResize);
      */

      /*
       * Initialize all Reveal's
       */

      var $ShippingAdvisory = {};
      var $BreakingNews = {};
      var $PostalCodeRestriction = {};
      var $ExternalLink = {};

      // Advisory Message
      if ($('#ShippingAdvisory').length != 0) {
        var $ShippingAdvisory = $('#ShippingAdvisory');
        new Foundation.Reveal($ShippingAdvisory);
      }

      // Breaking News Message
      if ($('#BreakingNews').length != 0) {
        var $BreakingNews = $('#BreakingNews');
        new Foundation.Reveal($BreakingNews);
      }

      // Breaking News Message
      if ($('#PostalCodeRestriction').length != 0) {
        var $PostalCodeRestriction = $('#PostalCodeRestriction');
        new Foundation.Reveal($PostalCodeRestriction);
      }

      // External Link Message
      if ($('.modal-warning').length != 0) {
        var $ExternalLink = $('.modal-warning');
        new Foundation.Reveal($ExternalLink);
      }


      // listen to when the Age Gate is opened
      dom.addEventListener('AgeGateOpened', function (e) {
        // e.target matches elem
      }, false);

      // listen to when the Age Gate is closed
      dom.addEventListener('AgeGateClosed', function (e) {
        // e.target matches elem
        /*
         * With POC features launched and ON shipping only enabled
         * we'll let Shopify take care of the messaging
         * but we'll keep this just in case we need to make it more
         * clear to users that we are only shipping within ON
        if ( window.location.pathname == "/collections/shop" ) {
          var advisory_cookie_name = ['corby', 'advisory', CORBY.Site.getBrandId(), CORBY.Site.getLang()].join('-');
          if (CORBY.Cookie.read( advisory_cookie_name ) == null) {
            setTimeout(function () {
              if ($('#ShippingAdvisory .message').text() != "") {
                $ShippingAdvisory.foundation('open');
                CORBY.Cookie.create(
                  advisory_cookie_name,
                  'true',
                  1
                );
              }
            }, 500);
          }
        }
        */

        // show Evidon banner
        setTimeout(function () {
          var style = $( "#_evidon_banner" ).attr('style');
          style += " bottom: 0px !important;";
          $('#_evidon_banner').attr('style', style);
        }, 3000);

        // Ensure Shipping Optin is checked
        $('body').on('click', '[data-validate-postal-code]', function( evt ) {
          var users_pc = $('[data-validate-my-postal-code]').val();
          var regex = /[A-Za-z][0-9][A-Za-z][0-9][A-Za-z][0-9]/gi;
          if (users_pc.match(regex) == null || users_pc.length != 6) alert('Please match the format A0A1A1');
            else {
              validate_users_pc ( users_pc );
            }

          return false;
        });

        if ($('[data-validate-postal-code]').length !== 0) {
          var rememberpc_cookie_name = ['corby', 'rememberpc', CORBY.Site.getBrandId(), CORBY.Site.getLang()].join('-');
          if (CORBY.Cookie.read( rememberpc_cookie_name ) == null) $('.on, .product-form').show();
            else {
              returning_pc_users ( CORBY.Cookie.read( rememberpc_cookie_name ) );
            }
        }

        if ( $('#BreakingNews').length != 0 ) {
          var breakingnews_cookie_name = ['corby', 'breakingnews', CORBY.Site.getBrandId(), CORBY.Site.getLang()].join('-');
          if (CORBY.Cookie.read( breakingnews_cookie_name ) == null) {
            setTimeout(function () {
              if ($('#BreakingNews .message').text() != "") {
                $BreakingNews.foundation('open');
                CORBY.Cookie.create(
                  breakingnews_cookie_name,
                  'true',
                  1
                );
              }
            }, 500);
          }
        }
      }, false);

      // Ensure Shipping Optin is checked
      $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
          if ($("#shipping").is(":visible")) {
            if ($('#shipping').is(':checked')) {
              $(this).submit();
            } else {
              $('.shipping-opt-in .error').show();
              return false;
            }
          }
      });

      // Ensure Pickup Optin is checked
      $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
          if ($("#pickup").is(":visible")) {
            if ($('#pickup').is(':checked')) {
              $(this).submit();
            } else {
              $('.pickup-opt-in .error').show();
              return false;
            }
          }
      });

      // show modal and reject checkout request if more than 2 bottles in cart
      $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
        var bottleCountNode = $("#cart-bottle-count-data");
        if (bottleCountNode.length) {
          var bottleCountData = JSON.parse(bottleCountNode[0].innerText);
          if (bottleCountData.bottleCount > 2) {
            $("body").addClass("no-scroll");
            var modalWrapper = $(".bottle-limit-modal-wrapper");
            if (modalWrapper.length) {
              modalWrapper.removeClass("hidden");
            }
            return false;
          }
        }
        $(this).submit();
      });

      // Product Add to Cart
      $('body').on('click', '[data-add-to-cart]', function() {

        // check for event terms modal and show it instead of adding to cart
        var eventTermsModal = $('.event-terms-modal.modal-wrapper');
        if ( $('#EventTermsModal').length && eventTermsModal.hasClass('hidden') ) {
          eventTermsModal.removeClass('hidden');
          $('body').addClass('no-scroll');
          return false;
        }

        // check for Postal Code Restrictions feature
        if ( $('.has_restrictions').length != 0)
        {
          // check if disabled
          var p = $(this).parent().parent().parent().parent().parent().parent();

          //cell large-8 pc-restriction-callout has_restrictions product-form
          if (p.hasClass('has_restrictions')) {
            alert('Please enter your postal code to continue');
            var target = $('.pc-restriction-callout.on');
            $('html,body').animate({
              scrollTop: target.offset().top - 180
            }, 1000);

            return false;
          }
        }

        if (typeof PIVAddtoCart === 'function') {
          PIVAddtoCart();
        }
      });
    }
  };
}(CORBY, jQuery, document, window));

CORBY.Cookie = (function (Corby, $) {
  var
      id = 'CORBY.Cookie',

      __constructor = function () {
        // do nothing for now...
      }();

  function _readCookie( name ) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  function _createCookie( name, value, days ) {
    var expires = "";

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = date.toGMTString();
    }
    document.cookie = name + "=" + value + ';expires=' + expires + ";path=/";
  }

  function _eraseCookie( name ) {
    _createCookie(name, "", -1);
  }

  return {
    getId: function () {
      return id;
    },

    getRememberName: function () {
      return ['corby', 'remember', Corby.Site.getBrandId(), Corby.Site.getLang()].join('-');
    },

    getAgeGateName: function ( lang ) {
      if (!lang) {
        return ['corby', 'agegate', Corby.Site.getBrandId(), Corby.Site.getLang()].join('-');
      }

      return ['corby', 'agegate', Corby.Site.getBrandId(), lang].join('-');
    },

    getLocationName: function ( selected_location ) {
      return ['corby', 'location', Corby.Site.getBrandId(), selected_location].join('-');
    },

    read: _readCookie,
    create: _createCookie,
    erase: _eraseCookie
  };
}(CORBY, jQuery));

CORBY.URL = (function (Corby, $) {
  var
      id = 'CORBY.URL',

      /*
       * Current URL Parameters
       */
      params,

      __constructor = function () {
      }();

  /*
   * Get the current urls' query string and return the requested parameter
   *
   * @return string
   */

  function _getParameter ( p ) {
    var search_string = decodeURIComponent(window.location.search.substring(1)),
        search_string_as_array = search_string.split('&'),
        search_array_element,
        len = search_string_as_array.length,
        i;

    for (i = 0; i < len; i++) {
      search_array_element = search_string_as_array[i].split('=');
      if ( search_array_element[0] === p ) {
        return search_array_element[1] === undefined ? true : search_array_element[1];
      }
    }
  }

  return {
    getId: function () {
      return id;
    },

    getParameter: function ( p ) {
      return _getParameter ( p );
    }
  };
}(CORBY, jQuery));

CORBY.AgeGate = (function (Corby, $, dom, win) {
  var
      id = 'CORBY.AgeGate',

      $AgeGate = $('#AgeGate'),

      openEvent = dom.createEvent('Event');
      openEvent.initEvent('AgeGateOpened', true, true);

      closeEvent = dom.createEvent('Event');
      closeEvent.initEvent('AgeGateClosed', true, true);

      __constructor = function () {
        // some code
        new Foundation.Reveal($AgeGate);
      }();

  /*
   * Set cookies and hides Age Gate
   *
   * @param $AgeGate jQuery reference to the Age Gate element
   *
   * @return void
   */
  function _user_is_of_lda( $AgeGate ) {

    // create cookie based on language code
    Corby.Cookie.create(
      Corby.Cookie.getAgeGateName(),
      'true',
      28
    );

    // Check for 'Remember Me'
    if ($('#remember').is(':checked')) {
      Corby.Cookie.create(
        Corby.Cookie.getRememberName(),
        'true',
        28
      );
    }

    // close the Age Gate
    _close();
  }

  /*
   * Hide OptIns and show 'No Messaging' container
   *
   * @param $AgeGate jQuery reference to the Age Gate element
   *
   * @return void
   */
  function _user_is_not_lda( $AgeGate ) {
    $('.agegate-form').hide();
    $('.agegate-no-optin').show();
  }

  /*
   * Checks to see if we are being asked to bypass the age gate
   *
   * @return boolean
   */
  function _bypass_age_gate () {
    var skip_age_gate = Corby.URL.getParameter('age-verified');
    if (typeof skip_age_gate !== 'undefined') {
      return true;
    }

    return false;
  }

  /*
   * Checks to see if the remember cookie is set
   *
   * @return boolean
   */
  function _check_remember_me() {
    if (Corby.Cookie.read( Corby.Cookie.getRememberName() ) === 'true') {
      return true;
    }

    return false;
  }

  /*
   * Checks to see if the Age Gate cookie is set
   *
   * @return boolean
   */
  function _check_agegate_cookie() {
    if (Corby.Cookie.read(Corby.Cookie.getAgeGateName()) === 'true') {
      return true;
    }

    return false;
  }

  /*
   * Shows' users the Age Gate
   *
   * @return void
   */
  function _open () {
    $AgeGate.foundation('open');

    slate.a11y.trapFocus({
      $container: $AgeGate,
      namespace: 'modal'
    });

    $('body').addClass('noscroll');
    $('html, body').animate({
      scrollTop: 0
    }, 0);

    $AgeGate
      .find('button')
      .click(function(evt) {
        evt.preventDefault();

        // which button did they click?
        var button_id = $(this).text();
        switch (button_id) {
          case "Yes":
            _user_is_of_lda( $AgeGate );
            break;
          default:
            _user_is_not_lda( $AgeGate );
            break;
        }
      });

      dom.dispatchEvent(openEvent);
  }

  /*
   * Closes' the Age Gate
   *
   * @return void
   */
  function _close () {
    slate.a11y.removeTrapFocus({
      $container: $AgeGate,
      namespace: 'modal'
    });

    $('body').removeClass('noscroll');
    $('html, body').animate({
      scrollTop: 0
    }, 0);

    $AgeGate.foundation('close');

    dom.dispatchEvent(closeEvent);
  }

  return {
    init: function () {

      // check to see if we should bypass our age gate
      if (_bypass_age_gate()) {
        dom.dispatchEvent(closeEvent);

        Corby.Cookie.create(
          Corby.Cookie.getAgeGateName(),
          'true',
          1
        );

        return;
      }

      // check to see if user asked to be remembered
      if (_check_remember_me()) {
        dom.dispatchEvent(closeEvent);
        return;
      }

      // check to see if cookies are set
      if (_check_agegate_cookie()) {
        dom.dispatchEvent(closeEvent);
        return;
      }

      // check if user is coming from jpwisers.com
      if (document.referrer.indexOf('jpwisers.com') != -1) {
        dom.dispatchEvent(closeEvent);

        Corby.Cookie.create(
          Corby.Cookie.getAgeGateName(),
          'true',
          1
        );

        return;
      }

      // show age gate
     _open();
    }
  };
}(CORBY, jQuery, document, window));



$(document).ready(function() {

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Smooth Scrolling
  $('.site-nav a').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 104
        }, 1000);
        return false;
      }
    }
  });

  // Qty Up/Down Buttons on Product pages
  var qtyTarget = $('#Quantity')
  var qtyValue = qtyTarget.attr('value');
  var changeEvent = new CustomEvent('pdp:qtychange');
  qtyTarget.val(qtyValue);

  $('#qtyUp').on('click', function ( evt ) {
    var qtyTarget = $('#Quantity'),
    qtyMax = qtyTarget.attr('max');
    if (qtyValue < qtyMax) {
      qtyTarget.val( ++qtyValue );
    }
    document.dispatchEvent(changeEvent);
  });
  
  $('#qtyDown').on('click', function ( evt ) {
    var qtyTarget = $('#Quantity'),
    qtyMin = qtyTarget.attr('min');
    if (qtyValue > qtyMin) {
      qtyTarget.val( --qtyValue );
    }
    document.dispatchEvent(changeEvent);
  });

  // Qty Up/Down Buttons on Cart page
  $('.cartQtyUpButton').on('click', function ( evt ) {
    var qtyTarget = $('#Quantity'),
    qtyMax = qtyTarget.attr('max');
    var cartQtyTarget = $(this).parent().parent().find('input[type="number"]'),
        cartQtyMax = parseInt(cartQtyTarget.attr('max'));
        cartQtyValue = parseInt(cartQtyTarget.val());

        if (cartQtyValue < cartQtyMax) {
          cartQtyTarget.val( ++cartQtyValue );
        }
    $('input[name="update"]').click(); // updates product option qtt along with product qtt
  });

  $('.cartQtyDownButton').on('click', function ( evt ) {
    var cartQtyTarget = $(this).parent().parent().find('input[type="number"]'),
        cartQtyValue = cartQtyTarget.val();

        if (cartQtyValue > 1) {
          cartQtyTarget.val( --cartQtyValue );
        }
    $('input[name="update"]').click(); // updates product option qtt along with product qtt
  });

  // Enable Steal Toe Shoes Terms & Condition checkbox on Shopping Cart page
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($("#shoes-rights").is(":visible")) {
        if ($('#shoes-rights').is(':checked')) {
          $(this).submit();
        } else {
          $('.shoes-opt-in .error').show();
          return false;
        }
      }
  });

  /*
   * Fathers Day - Reminder
  // Enable Steal Toe Shoes Terms & Condition checkbox on Shopping Cart page
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($("#fathersday").is(":visible")) {
        if ($('#fathersday').is(':checked')) {
          $(this).submit();
        } else {
          $('.fathersday-opt-in .error').show();
          return false;
        }
      }
  });
   */

  // Enable 'Terms & Condition' checkbox on Shopping Cart page
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    } else {
      $('.terms-opt-in .error').show();
      return false;
    }
  });

  // There are limits to each type of order....
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {

    var line = [];
    var has_errors = false;

    $( "td[data-label='Product']" ).each(function( index ) {
      line.push( {
        el: $(this).parent(),
        qty: Number( $(this).parent().find('input[type="number"]').val() ),
        max: Number( $(this).parent().find('input[type="number"]').attr('max') ),
        vendor: $(this).data('vendor'),
        engrave: $(this).data('engrave')
      });
    });

    var n = -1, m = line.length, qty, max;
    while (++n < m) {
      qty = line[n]['qty'];
      max = line[n]['max'];
      engrave = line[n]['engrave'];

      // check if line item exceeds its maxinum
      if (qty > max) {
        line[n]['el'].find('.qtyMaxError').html("<p>Max QTY is " + max + "</p>").show();

        // Check we don't exceed more than 10 engraved bottles
        if (engrave == "true") {
          $('.engraved-quantity-error .error').show();
          $(line[n]['el']).addClass('error');
        }

        has_errors = true;
      }
    }

    if (has_errors) {
      $('.quantity-error .error').show();
      return false;
    } else {
      $(this).submit();
    }

  });

  // Initiate CORBY WebApp
  CORBY.Site.init();

  // Initiate AgeGate
  CORBY.AgeGate.init();
});
